import { AuthorsService } from "../client"

/* ENDPOINTS */
export const getAuthor = ({authorId} : {authorId: string}) => {
    return {
        queryFn: async () => {
            const data = await AuthorsService.readAuthorPublic({ authorId: authorId })
            return data ?? { data: null, count: 0 }
        },
        queryKey: ["author", { authorId }],
        retry: false,
    }
}